import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { translate } from "react-i18next";
import {
  FormControlLabel,
  Switch,
  Button,
  Grid,
  Paper,
} from "@material-ui/core";

import { withStyles } from "@material-ui/core/styles";
import Loading from "../loading";
import Snackbar from "../snackbar";
import "../../css/voucher.css";
import InputFormat from "../../partials/inputForm";
import { getNumberOnString } from "../../partials/validateNumber";

const styles = (theme) => ({
  paper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    padding: theme.spacing(2),
  },
});
class EditUserVoucher extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: JSON.parse(JSON.stringify(this.props.data || {})),
      times: this.props.data ? this.props.data.times : 0,
      checked: false,
    };
  }
  handleInputChange = (event) => {
    let data = this.state.data;
    if (event.target.name === "times") {
      data[event.target.name] = getNumberOnString(event.target.value);
    }
    data[event.target.name] = event.target.value;
    this.setState(data);
  };
  handleCheck = async () => {
    let { t } = this.props;
    let { data } = this.state;
    let times = JSON.parse(JSON.stringify(this.props.data || {})).times;
    if (data.times <= 0)
      this.mSnackbar.handleClick(t("user_voucher_times_is_not_valid"));
    else if (times - data.isUsed > data.times)
      alert(
        t("user_voucher_customer_has_used") +
          " " +
          (times - data.isUsed) +
          " " +
          t("user_voucher_times")
      );
    else {
      this.loading.startLoading();
      data.sendNotify = this.state.checked;
      let check = await this.props.updateTimesUserVoucher(data);
      this.loading.stopLoading();
      this.props.afterEdit(check);
    }
  };
  handleChangeSwitch = (e) => {
    this.setState({
      checked: e.target.checked,
    });
  };
  render() {
    const { classes, t } = this.props;
    const { data } = this.state;
    return (
      <Paper className={classes.paper}>
        <Loading onRef={(id) => (this.loading = id)} />
        <Snackbar
          color="white"
          onRef={(snackbar) => (this.mSnackbar = snackbar)}
        />
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={6}>
            <InputFormat
              type="number"
              label={t("user_voucher_times_the_voucher_is_used")}
              name="times"
              margin="normal"
              required
              value={data.times}
              onChange={this.handleInputChange}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <FormControlLabel
              className={classes.formControlLabel}
              control={
                <Switch
                  checked={this.state.checked}
                  onChange={this.handleChangeSwitch}
                  value="Send notify to customer"
                />
              }
              label={t("user_voucher_send_notify_to_customer")}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} className={classes.wrapButton}>
            <Button
              variant="contained"
              color="primary"
              onClick={this.handleCheck}
            >
              {t("voucher_addvoucher_save")}
            </Button>
          </Grid>
        </Grid>
      </Paper>
    );
  }
}

EditUserVoucher.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapState = (state) => ({});

const mapDispatch = (dispatch) => ({
  updateTimesUserVoucher: dispatch.userVouchers.updateTimesUserVoucher,
});

export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(styles, { withTheme: true })(EditUserVoucher)
  )
);
